module.exports = __webpack_public_path__ + "img/Aura_glow.3e17b26b.png";